import styled from "styled-components";
import { Color, Font, Opacity, responsive } from "../../utils/style";
import MessageBanner from "../MessageBanner";
import { useSelector } from "react-redux";
import userSelectors from "../../store/user/selectors";
import { Icons } from "../../utils/react-svg";
import { useState } from "react";
import PromotionDetailsModal from "./PromotionDetailsModal";
import { Link } from "gatsby";
import intlService from "../../services/intl";

const BannerContent = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 12px;

  ${responsive.md`
    padding-top: 12px;
    padding-bottom: 14px;
  `}

  p {
    ${Font.circular}
    letter-spacing: 0;
    margin-bottom: 0;
  }

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      color: inherit;
    }
  }
`;

const TooltipButton = styled.button`
  background: transparent;
  border: none;
  opacity: ${Opacity.light};
  height: 16px;
  width: 16px;
  display: inline;
  position: relative;
  padding: 0;
  margin-left: 8px;
  vertical-align: text-bottom;

  &:hover {
    opacity: 1;
  }

  [data-whatintent="mouse"] &:focus,
  [data-whatintent="touch"] &:focus {
    outline: none;
  }

  svg {
    position: absolute;
    height: 16px;
    width: 16px;
    margin-left: 1px;
    top: 0;
    left: 0;
  }
`;

const ShopLink = styled(Link)`
  text-decoration: underline;
  margin-left: var(--spacing-0_5);
`;

export default function CustomBanner(props) {
  const { content } = props;
  const authenticated = useSelector(userSelectors.isLoggedIn);
  const [modalOpen, setModalOpen] = useState(false);

  if (authenticated && content?.prospects) return null;

  const hasTooltip = content?.tooltip && content?.tooltip?.copy;

  function openModal() {
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
  }

  return (
    <MessageBanner {...props}>
      <BannerContent>
        <p className="d-md-flex align-items-center justify-content-center text-center typography-body2">
          {content?.copy}
          {content?.slug && (
            <ShopLink to={`${intlService.localizePath(`${content?.slug}`)}`}>
              {content?.linkText || "Shop Now"}
            </ShopLink>
          )}
          {hasTooltip && (
            <TooltipButton onClick={openModal}>
              <Icons.Info $color={Color.white} />
            </TooltipButton>
          )}
        </p>
      </BannerContent>

      <PromotionDetailsModal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        title={content?.tooltip?.title || "Promo Details"}
        body={content?.tooltip?.copy || ""}
      />
    </MessageBanner>
  );
}
